import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { lazy } from 'utils/generic/lazy';
import 'components/AccountUI/index.less';
import { getPartnerConfigs } from 'store/selectors/socket';

const { LoyaltyPoints } = lazy(
  () => import(/* webpackChunkName: "loyalty-points" */ '../LoyaltyPoints')
);

const { LoyaltyPointsNew } = lazy(
  () =>
    import(/* webpackChunkName: "loyalty-points-v2" */ '../LoyaltyPointsNew')
);

export const LoyaltyPointsVersionsWrapper = () => {
  const partnerConfigs = useSelector(getPartnerConfigs);

  const isLoyaltyV2 = !!partnerConfigs?.is_loyalty_v2;

  return (
    <Suspense>
      {isLoyaltyV2 ? <LoyaltyPointsNew /> : <LoyaltyPoints />}
    </Suspense>
  );
};
